<template>
  <BaseVeeForm
    :action="save"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-2"
  >
    <div>
      <ValidationProvider rules="required|e164phone" name="number" slim vid="number">
        <template #default="{ errors }">
          <BaseFormGroup>
            <BaseFormInput
              type="text"
              v-model="formData.number"
              :disabled="disabled || isPending"
              @focus="showActions = true"
            />
            <BaseFormInlineMessage v-if="errors.length" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
    </div>

    <div v-if="forceActionsVisibility || showActions" class="flex space-x-2">
      <BaseButton primary small :disabled="disabled || invalid || isPending"> Save </BaseButton>
      <BaseButton
        type="button"
        primary
        outline
        small
        :disabled="disabled || isPending"
        @click="onCancel"
      >
        Cancel
      </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    saveAction: {
      type: Function,
      required: true,
    },
    phoneNumber: {
      type: Object,
      default: () => ({}),
    },
    forceActionsVisibility: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      showActions: false,
      saving: false,
      formData: {
        number: this.phoneNumber.number || '',
      },
    };
  },
  methods: {
    async save() {
      try {
        this.saving = true;
        await this.saveAction(this.formData);
        this.$emit('saved');
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.saving = false;
      }
    },
    onCancel() {
      this.showActions = false;
      this.$emit('canceled');
    },
  },
};
</script>
